/**
 * responsive.js — shared responsive helper + breakpoints.
 *
 * Single source for the responsive() helper previously duplicated across
 * sgpFlowStyles, ProfilePage, HomeScreen, SearchInput, and SgpFlowScreen.
 * Evaluated at module load (matches the pre-extraction behavior where each
 * file computed these once at module scope, not per-render).
 */

import { Dimensions } from 'react-native';

const { width } = Dimensions.get('window');
export const SCREEN_WIDTH = width;
export const SCREEN_HEIGHT = Dimensions.get('window').height;
export const isMobile = width < 768;
export const isTablet = width >= 768 && width < 1024;

export const responsive = (mobile, tablet, desktop) => {
  if (isMobile) return mobile;
  if (isTablet) return tablet;
  return desktop;
};
